import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Timeline } from '@node-space/ui-components'
import { Card } from 'services/CardService'
import { getCardActivityItems } from './utils/cardActivityUtils'

interface CardActivityTabProps {
  card: Card
}

export const CardActivityTab = ({ card }: CardActivityTabProps) => {
  const { t } = useTranslation()
  const items = getCardActivityItems(card, t)

  return (
    <Box paddingT={16} width="full">
      <Timeline items={items} full />
    </Box>
  )
}
